<template>
  <div class="pa-10">
    <h1 class="display-1 text-center mb-8">Covid Test</h1>
    <form class="personal-info d-flex flex-column" @submit.prevent="submit">
      <div class="subtitle-1 font-weight-bold mb-6">2. {{$t('cellexTest.third.thirdTitle')}}</div>

      <p>{{$t('cellexTest.third.thirdSubtitle')}}</p>
      <v-checkbox
        class="pa-0 ma-0"
        :label="$t('cellexTest.third.coughLabel')"
        v-model="questionnaire.cough"
      ></v-checkbox>
      <v-checkbox
        class="pa-0 ma-0"
        :label="$t('cellexTest.third.breathlessnessLabel')"
        v-model="questionnaire.breathlessness"
      ></v-checkbox>

      <p>{{$t('cellexTest.third.thirdSubtitle2')}}</p>
      <v-checkbox
        class="pa-0 ma-0"
        :label="$t('cellexTest.third.feverLabel')"
        v-model="questionnaire.fever"
      ></v-checkbox>
      <v-checkbox
        class="pa-0 ma-0"
        :label="$t('cellexTest.third.coldsLabel')"
        v-model="questionnaire.colds"
      ></v-checkbox>
      <v-checkbox
        class="pa-0 ma-0"
        :label="$t('cellexTest.third.shiverLabel')"
        v-model="questionnaire.shiver"
      ></v-checkbox>
      <v-checkbox
        class="pa-0 ma-0"
        :label="$t('cellexTest.third.muscularPainLabel')"
        v-model="questionnaire.muscularPain"
      ></v-checkbox>
      <v-checkbox
        class="pa-0 ma-0"
        :label="$t('cellexTest.third.headacheLabel')"
        v-model="questionnaire.headache"
      ></v-checkbox>
      <v-checkbox
        class="pa-0 ma-0"
        :label="$t('cellexTest.third.soreThroatLabel')"
        v-model="questionnaire.soreThroat"
      ></v-checkbox>
      <v-checkbox
        class="pa-0 ma-0"
        :label="$t('cellexTest.third.noTasteLabel')"
        v-model="questionnaire.noTaste"
      ></v-checkbox>
      <v-divider></v-divider>
      <v-checkbox
        :label="$t('cellexTest.third.liveInQuarantinedPlaceLabel')"
        v-model="questionnaire.liveInQuarantinedPlace"
      ></v-checkbox>
      <v-divider></v-divider>
      <v-checkbox
        :label="$t('cellexTest.third.familyHasCovidLabel')"
        v-model="questionnaire.familyHasCovid"
      ></v-checkbox>
      <v-divider></v-divider>
      <v-checkbox
        :label="$t('cellexTest.third.lastTwentyOneDaysLabel')"
        v-model="questionnaire.lastTwentyOneDays"
      ></v-checkbox>
      <v-divider></v-divider>
      <v-checkbox
        :label="$t('cellexTest.third.goneHospitalLabel')"
        v-model="questionnaire.goneHospital"
      ></v-checkbox>
      <v-divider></v-divider>
      <v-checkbox :label="$t('cellexTest.third.diseasesLabel')" v-model="questionnaire.diseases"></v-checkbox>

      <v-btn
        color="primary"
        depressed
        class="align-self-center"
        type="submit"
      >{{$t('cellexTest.third.btn')}}</v-btn>
    </form>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      questionnaire: {
        cough: false,
        breathlessness: false,
        fever: false,
        colds: false,
        shiver: false,
        muscularPain: false,
        headache: false,
        soreThroat: false,
        noTaste: false,
        liveInQuarantinedPlace: false,
        familyHasCovid: false,
        lastTwentyOneDays: false,
        goneHospital: false,
        diseases: false
      }
    };
  },
  created() {
    this.questionnaire.cough = this.newCellexTest?.questionnaire?.cough;
    this.questionnaire.breathlessness = this.newCellexTest?.questionnaire?.breathlessness;
    this.questionnaire.fever = this.newCellexTest?.questionnaire?.fever;
    this.questionnaire.colds = this.newCellexTest?.questionnaire?.colds;
    this.questionnaire.shiver = this.newCellexTest?.questionnaire?.shiver;
    this.questionnaire.muscularPain = this.newCellexTest?.questionnaire?.muscularPain;
    this.questionnaire.headache = this.newCellexTest?.questionnaire?.headache;
    this.questionnaire.soreThroat = this.newCellexTest?.questionnaire?.soreThroat;
    this.questionnaire.noTaste = this.newCellexTest?.questionnaire?.noTaste;
    this.questionnaire.liveInQuarantinedPlace = this.newCellexTest?.questionnaire?.liveInQuarantinedPlace;
    this.questionnaire.familyHasCovid = this.newCellexTest?.questionnaire?.familyHasCovid;
    this.questionnaire.lastTwentyOneDays = this.newCellexTest?.questionnaire?.lastTwentyOneDays;
    this.questionnaire.goneHospital = this.newCellexTest?.questionnaire?.goneHospital;
    this.questionnaire.diseases = this.newCellexTest?.questionnaire?.diseases;
  },
  computed: {
    ...mapState({
      newCellexTest: state => state.frontDesk.newCellexTest
    })
  },
  methods: {
    ...mapActions(["newCellexTestThird"]),
    submit() {
      this.newCellexTestThird({
        questionnaire: this.questionnaire
      });
    }
  }
};
</script>